import { NavigateFunction } from 'react-router-dom';
import { BRAIN_IT_WINDOW_OPEN_TARGET } from 'env';
import { EXTERNAL_REDIRECT_PAGE_PATH } from 'routes/paths';

/**
 * Opens a BrainIT URL. If the configured target is '_blank', navigates to an
 * intermediate "leaving Objekto" page instead of opening a new tab directly.
 * Otherwise, falls back to window.open with the configured target.
 */
export default function openBrainItUrl(redirectUrl: string, navigate?: NavigateFunction) {
  if (BRAIN_IT_WINDOW_OPEN_TARGET === '_blank') {
    const url = `${EXTERNAL_REDIRECT_PAGE_PATH.original}?targetUrl=${encodeURIComponent(redirectUrl)}`;

    if (navigate) {
      navigate(url);
      return;
    }

    window.location.assign(url);
  } else {
    window.open(redirectUrl, BRAIN_IT_WINDOW_OPEN_TARGET);
  }
}
